import { Injectable } from '@angular/core';
import { HttpRequestService } from '../http-request/http-request.service';
import { UtilitiesService } from '../utilities/utilities.service';
import { UrlEnum } from '../../enums/url.enum';
import { map, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SmsLogService {
  private smsApi = UrlEnum.OTITHI_AUTH + '/alert';

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly httpRequestService: HttpRequestService
  ) {}

  public getAllSmsAlert(query: {
    propertyId?: string;
    alertType?: string;
    status?: string;
    page?: number;
    limit?: number;
    orderBy?: string;
    orderDirection?: 'asc' | 'desc';
    purpose?: string;
    search?: string;
  }): Observable<any> {
    let params = new HttpParams();

    if (query.propertyId) {
      params = params.set('propertyId', query.propertyId);
    }

    if (query.alertType) {
      params = params.set('alertType', query.alertType);
    }

    if (query.status) {
      params = params.set('status', query.status);
    }

    if (query.page !== undefined) {
      params = params.set('page', query.page.toString());
    }

    if (query.limit !== undefined) {
      params = params.set('limit', query.limit.toString());
    }

    if (query.orderBy) {
      params = params.set('orderBy', query.orderBy);
    }

    if (query.orderDirection) {
      params = params.set('orderDirection', query.orderDirection);
    }

    if (query.purpose) {
      params = params.set('purpose', query.purpose);
    }

    if (query.search) {
      params = params.set('search', query.search);
    }

    return this.httpRequestService
      .get<any>(`${this.smsApi}/get-alerts`, { params })
      .pipe(map((x: any) => this.utilitiesService.responseHandler(x)));
  }

  public smsAlertLogs(query: {
    propertyId: string;
    alertType?: string;
    status?: string;
    page?: number;
    limit?: number;
    orderBy?: string;  
    orderDirection?: 'asc' | 'desc';
    search?: string;
    purpose?: string;
    alertId?: string;
  }): Observable<any> {
    let params = new HttpParams();

    params = params.set('propertyId', query.propertyId);

    if (query.alertType) {
      params = params.set('alertType', query.alertType);
    }

    if (query.status) {
      params = params.set('status', query.status);
    }

    if (query.page !== undefined) {
      params = params.set('page', query.page.toString());
    }

    if (query.limit !== undefined) {
      params = params.set('limit', query.limit.toString());
    }

    if (query.orderBy) {
      params = params.set('orderBy', query.orderBy);
    }

    if (query.orderDirection) {
      params = params.set('orderDirection', query.orderDirection);
    }

    if (query.search) {
      params = params.set('search', query.search);
    }

    if (query.purpose) {
      params = params.set('purpose', query.purpose);
    }

    if (query.alertId) {
      params = params.set('alertId', query.alertId);
    }

    return this.httpRequestService
      .get<any>(`${this.smsApi}/get-alert-logs`, { params })
      .pipe(map((x: any) => this.utilitiesService.responseHandler(x)));
  }
}
